// utils/location.util.ts
import MapService from "services/map.service";

export interface ParsedAddress {
  value: string;
  details: {
    city?: string;
    route?: string;
    airport: boolean;
    geometry: {
      location: { lat: number; lng: number };
    };
    name: string;
    country_name_code?: string;
    [key: string]: any; // keep flexibility
  };
}

export async function parseAddressFromLatLng(
  lat: number,
  lng: number
): Promise<ParsedAddress | null> {
  try {
    const res: any = await MapService.getAddressFromLatLng(lat, lng);

    if (!res) return null;

    let airport = false;
    let city: string | undefined;
    let route: string | undefined;
    let country_name_code: string | undefined;

    const location = res.geometry.location;
    const geometry = {
      location: { lat: location.lat(), lng: location.lng() },
    };

    res.address_components.forEach(
      ({ types, long_name, short_name }: any) => {
        if (types.includes("route")) route = long_name;
        if (types.includes("locality")) city = long_name;
        if (types.includes("country")) country_name_code = short_name;
      }
    );

    if (res.types?.includes("airport")) airport = true;

    const startTitle = res?.formatted_address
      ?.split(/[،,]+/)
      .slice(0, 2)
      .join(",");

    const details = {
      ...res,
      city,
      route,
      airport,
      geometry,
      name: startTitle,
      country_name_code,
    };

    return {
      value: res.formatted_address,
      details,
    };
  } catch (error) {
    console.error("Error parsing address:", error);
    return null;
  }
}
